import ActionTypes from "../../../../constants/ActionTypes";
import {
  IRequestFetchCampaignDetailsAction,
  ISubmitEanex,
  ISetCampaignDetailsAction,
  ISetDetailsIsUpSellAction,
  ISetDetailsOptionNameAction,
  ISetDetailsSoftOfferPackageAction,
  ISetDetailsTermsAction,
  ISetDetailsOfferId,
  ISetDetailsOptionId,
  ISetDetailsChannelName, ISubmitEanexMessage, ISetTypeSuffix
} from "./types";
import { ISoftOfferPackage } from "../../../../entities/campaigns/types";

export function requestFetchCampaignDetailsAction(params: object): IRequestFetchCampaignDetailsAction {
  return {
    type: ActionTypes.CAMPAIGN.DETAILS.FETCH,
    params,
  };
}

export function setCampaignDetailsAction(params: object): ISetCampaignDetailsAction {
  return {
    type: ActionTypes.CAMPAIGN.DETAILS.CREATE,
    payload: params,
  };
}

export function setDetailsSoftOfferPackageAction(softPackage: ISoftOfferPackage): ISetDetailsSoftOfferPackageAction {
  return {
    type: ActionTypes.CAMPAIGN.DETAILS.SET_SOFT_OFFER_PACKAGE,
    payload: softPackage,
  };
}

export function setDetailsOptionNameAction(optionName: string): ISetDetailsOptionNameAction {
  return {
    type: ActionTypes.CAMPAIGN.DETAILS.SET_OPTION_NAME,
    payload: optionName,
  };
}

export function setDetailsTermsAction(terms: string): ISetDetailsTermsAction {
  return {
    type: ActionTypes.CAMPAIGN.DETAILS.SET_DETAILS_TERMS,
    payload: terms,
  };
}

export function setDetailsIsUpSellAction(isUpSell: boolean): ISetDetailsIsUpSellAction {
  return {
    type: ActionTypes.CAMPAIGN.DETAILS.SET_DETAILS_IS_UP_SELL,
    payload: isUpSell,
  };
}

export function setDetailsOfferIdAction(offerId: number | string): ISetDetailsOfferId {
  return {
    type: ActionTypes.CAMPAIGN.DETAILS.SET_DETAILS_OFFER_ID,
    payload: offerId,
  };
}

export function setDetailsOptionIdAction(optionId: number | string): ISetDetailsOptionId {
  return {
    type: ActionTypes.CAMPAIGN.DETAILS.SET_DETAILS_OPTION_ID,
    payload: optionId,
  };
}

export function setTypeSuffix(optionId? :string): ISetTypeSuffix {
  return {
    type: ActionTypes.CAMPAIGN.DETAILS.SET_TYPE_SUFFIX,
    payload: optionId,
  };
}

export function setDetailsChannelNameAction(channelName: string): ISetDetailsChannelName {
  return {
    type: ActionTypes.CAMPAIGN.DETAILS.SET_DETAILS_CHANNEL_NAME,
    payload: channelName,
  };
}

export function submitEanex(code: string): ISubmitEanex {
  return {
    type: ActionTypes.CAMPAIGN.DETAILS.SUBMIT_EANEX,
    payload: code
  };
}

export function setSubmitEanexMessage(message: string): ISubmitEanexMessage {
  return {
    type: ActionTypes.CAMPAIGN.DETAILS.SET_SUBMIT_EANEX_MESSAGE,
    payload: message
  };
}
